import * as React from 'react';
import styled from 'styled-components';
import Spinner from '../Spinner/Spinner';

const LoaderSpinner = styled(Spinner)`
  width: 64px;
  height: 64px;
  border-top: 5px solid ${({ theme }) => theme.colors.d5};
  border-right: 5px solid ${({ theme }) => theme.colors.d5};
  border-bottom: 5px solid ${({ theme }) => theme.colors.d5};
  border-left: 5px solid ${({ theme }) => theme.colors.secondary};
`;

const StyledModalLoader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LoaderPrimaryText = styled.p`
  margin: 40px 0 0 0;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.font1};
`;

const LoaderSecondaryText = styled.p`
  font-size: 14px;
  margin: 0;
  color: ${({ theme }) => theme.colors.font1};
`;

const ModalLoader = () => {
  return (
    <StyledModalLoader>
      <LoaderSpinner show />
      <LoaderPrimaryText>Please wait...</LoaderPrimaryText>
      <LoaderSecondaryText>Operation in progress</LoaderSecondaryText>
    </StyledModalLoader>
  );
};

export default ModalLoader;
